document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('header-component');

  if (!header) return;

  const scrollLimit = 700;

  function updateHeaderColor() {
    if (window.scrollY >= scrollLimit) {
      header.classList.add('color-after-scroll');
    } else {
      header.classList.remove('color-after-scroll');
    }
  }

  window.addEventListener('scroll', updateHeaderColor);

  updateHeaderColor();
});